import { MODAL_TOGGLE, MODAL_OPEN, MODAL_CLOSE } from "../types";

const initialState = {
  openedModal: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MODAL_TOGGLE:
      return {
        ...state,
        openedModal: action.payload !== state.openedModal ? action.payload : null,
      };
    case MODAL_OPEN:
      return {
        ...state,
        openedModal: action.payload,
      };
    case MODAL_CLOSE:
      return {
        ...state,
        openedModal: null,
      };
    default:
      return state;
  }
};
